import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[2]} 0 ${space[3]};
`;

export const MonthLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const NavControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[2]};
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${colors.fontPrimary};
  padding: 0;
  border-radius: 50%;
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const CalendarIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${colors.fontSecondary};
  padding: 0;
`;

export const WeekdayRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 4px;
`;

export const WeekdayLabel = styled.span`
  text-align: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  text-transform: uppercase;
  padding: 4px 0;
`;

export const DaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
`;

export const DayCell = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 2px;
  font-family: ${fonts.body};
  border-radius: 50%;
  transition: background-color 0.15s ease;

  &[data-today]:not([data-selected]) {
    background: ${colors.lighterGrey};
  }

  &[data-unavailable] {
    opacity: 0.35;
    cursor: not-allowed;
    pointer-events: none;
  }

  &[data-selected] {
    background: ${colors.primary};
    color: ${colors.white};
  }

  &[data-empty] {
    cursor: default;
    pointer-events: none;
  }

  &:hover:not([data-selected]):not([data-unavailable]):not([data-empty]) {
    background: ${colors.tertiary}66;
  }
`;

export const DayNumber = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.medium};
  line-height: 1.2;
  color: ${(p) => (p.$selected ? colors.white : colors.fontPrimary)};
`;

export const DayPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xxs};
  line-height: 1;
  color: ${(p) => (p.$selected ? colors.white : colors.fontSecondary)};
  white-space: nowrap;
`;
